module.exports = __webpack_public_path__ + "img/2fa-enabled-icon.e5c1d56e.svg";